/* The page's shared ground -- the tokens, the reset, the canvas, and the
   idioms more than one feature speaks: the .panel chrome, the micro-label,
   the .switch button row, the .hidden fade.  Everything feature-shaped lives
   in the sibling .css files with its feature; this file holds only what
   would otherwise be copied.  Imported first by ui/index.js, though almost
   nothing here depends on it -- the features override by specificity (ids),
   never by document order. */
:root{
  --ink:#f1efe8; --dim:#a7a79c; --accent:#e2a73c; --panel:rgba(20,21,18,.72);
  --edge:rgba(241,239,232,.14);
}
*{box-sizing:border-box}
html,body{margin:0;height:100%;overflow:hidden;background:#0e0f0d}
body{font-family:"IBM Plex Mono",ui-monospace,Menlo,monospace;color:var(--ink)}
#view{display:block;width:100vw;height:100vh;touch-action:none;cursor:pointer}

.panel{
  position:fixed;background:var(--panel);border:1px solid var(--edge);
  border-radius:4px;backdrop-filter:blur(9px);-webkit-backdrop-filter:blur(9px);
}
/* Was #hud .label; the happiness panel and the join card speak the same
   micro-label idiom, so the class went global rather than being copied. */
.label{font-size:.6rem;letter-spacing:.19em;text-transform:uppercase;color:var(--dim)}
/* The two-buttons row: the join card's Play/Build pair and #hud's cat
   switcher wear it, and the customizer's pattern chips borrow its chrome
   (panel.js's .cz-pat), so it lives here rather than with any one of them. */
.switch{display:flex;gap:6px}
.switch button{
  flex:1;font-family:inherit;font-size:.68rem;letter-spacing:.05em;padding:6px 0;
  color:var(--dim);background:transparent;border:1px solid var(--edge);
  border-radius:3px;cursor:pointer;transition:color .15s,border-color .15s,background .15s;
}
.switch button:hover{color:var(--ink);border-color:rgba(241,239,232,.32)}
.switch button.on{color:#171812;background:var(--accent);border-color:var(--accent);font-weight:500}
.switch button:focus-visible{outline:2px solid var(--accent);outline-offset:2px}

.hidden{opacity:0;visibility:hidden;transition:opacity .3s,visibility .3s}
@media (prefers-reduced-motion:reduce){
  .hidden{transition:none}
}
